// Zugriff auf Kanäle im Projekt: Spuren, Aux-Busse und Master haben alle eine Insert-Kette.
import type { InsertSlot, Project, Track } from '@srs/shared';
import { bussesOf, defaultBusses, pluginDef, resolveParams } from '../audio/plugins.ts';
import { uid } from './demo.ts';

export const SLOT_LETTERS = 'ABCDEFGHIJ';
export const MAX_INSERTS = 10;

/** Inserts eines Kanals lesen ('master', Spur-Id oder Bus-Id) */
export function channelInserts(p: Project, id: string): InsertSlot[] {
  if (id === 'master') return p.masterInserts ?? [];
  return p.tracks.find((t) => t.id === id)?.inserts ?? bussesOf(p).find((b) => b.id === id)?.inserts ?? [];
}
/** Inserts eines Kanals zum Ändern (legt Master-Liste und Standard-Busse bei Bedarf an) */
export function mutInserts(p: Project, id: string): InsertSlot[] {
  if (id === 'master') return (p.masterInserts ??= []);
  const t = p.tracks.find((x) => x.id === id);
  if (t) return t.inserts;
  p.busses ??= defaultBusses();
  return p.busses.find((b) => b.id === id)?.inserts ?? [];
}
/** Spur oder Bus zum Ändern (Fader, Pan, Mute) */
export function mutChannel(p: Project, id: string): Track | undefined {
  const t = p.tracks.find((x) => x.id === id);
  if (t) return t;
  p.busses ??= defaultBusses();
  return p.busses.find((b) => b.id === id);
}
export function channelName(p: Project, id: string) {
  if (id === 'master') return 'Master';
  return p.tracks.find((t) => t.id === id)?.name ?? bussesOf(p).find((b) => b.id === id)?.name ?? id;
}
/** neues Insert mit Standardwerten */
export function newSlot(pluginId: string, params?: Record<string, number>): InsertSlot {
  const def = pluginDef(pluginId)!;
  return { id: uid('ins'), role: def.role, plugin: def.id, params: params ?? (def.params.length ? resolveParams(def) : {}), bypass: false };
}
